<template>
  <b-card no-body>
    <b-table
      :fields="fields"
      :items="quoteDistribution.total_quote_items"
      class="table-bordered"
    >
      <template #thead-top="">
        <b-tr>
          <b-th
            colspan="2"
            class="text-center"
            style="background: none"
          >
            {{ $t('Organization') }}
          </b-th>
          <b-th
            colspan="2"
            class="text-center"
            style="background: none"
          >
            {{ $langName(getQuoteOrgType(quoteOrgTypeITM).name) }}
          </b-th>
          <b-th
            colspan="2"
            class="text-center"
            style="background: none"
          >
            {{ $langName(getQuoteOrgType(quoteOrgTypeOTM).name) }}
          </b-th>
        </b-tr>
      </template>
      <template #head()="data">
        {{ getHead(data) }}
      </template>
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template #cell(to_org)="data">
        {{ $langName(data.value.name) }}
      </template>

      <template #cell()="data">
        {{ getQuoteItemAmount(data) }}
      </template>
    </b-table>
  </b-card>
</template>

<script>
import {
  BCard, BTable, BTr, BTh,
} from 'bootstrap-vue'
import store from '@/store'

export default {
  components: {
    BCard,
    BTable,
    BTr,
    BTh,
  },
  props: {
    quoteDistribution: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getQuoteOrgType(id) {
      return this.$store.getters['staticModule/getQuoteOrgType'](id)
    },
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](id)
    },
    getHead(head) {
      const col = head.label
      if (Number(col) >= 100 && Number(col) <= 700) {
        return this.$langName(this.getDcType(Number(col)).name)
      }
      return this.$t(col)
    },
    getQuoteItemAmount(data) {
      const { orgType, dcType } = data.field.data
      const item = data.item.items.find(element => element.dc_type === dcType && element.org_type === orgType)
      return item ? item.amount : 0
    },
  },
  setup() {
    const {
      quoteOrgTypeOTM, quoteOrgTypeITM, quoteOrgTypeCommon,
      DSc, PhD, traineeResearcher,
    } = store.state.staticModule

    const fields = [
      { key: 'index', label: '#' },
      { key: 'to_org', label: 'To Org' },
      { key: 'dc_itm', label: `${DSc}`, data: { orgType: quoteOrgTypeITM, dcType: DSc } },
      { key: 'phd_itm', label: `${PhD}`, data: { orgType: quoteOrgTypeITM, dcType: PhD } },
      { key: 'dc_otm', label: `${DSc}`, data: { orgType: quoteOrgTypeOTM, dcType: DSc } },
      { key: 'phd_otm', label: `${PhD}`, data: { orgType: quoteOrgTypeOTM, dcType: PhD } },
      { key: 'trainee_researcher', label: `${traineeResearcher}`, data: { orgType: quoteOrgTypeCommon, dcType: traineeResearcher } },
    ]

    return {
      fields,
      quoteOrgTypeOTM,
      quoteOrgTypeITM,
      quoteOrgTypeCommon,
    }
  },
}
</script>

<style scoped>

</style>
